import { render, staticRenderFns } from "./DetailedTableSuelo.vue?vue&type=template&id=5cf78b0e&scoped=true"
import script from "./DetailedTableSuelo.vue?vue&type=script&lang=js"
export * from "./DetailedTableSuelo.vue?vue&type=script&lang=js"
import style0 from "./DetailedTableSuelo.vue?vue&type=style&index=0&id=5cf78b0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf78b0e",
  null
  
)

export default component.exports